module.exports = __webpack_public_path__ + "img/DEWAYA_2020_POSTER@0.5x.png";